import { connectSocket, sendMessage, onMessage, closeSocket } from "../socket";

const SocketStore = {
    state: {
        messages: [],
        socketConnected: false,
    },
    mutations: {
        ADD_MESSAGE(state, message) {
            state.messages.push(message);
            if (state.messages.length > 100) {
                state.messages.shift();
            }
        },
        SET_SOCKET_CONNECTED(state, status) {
            state.socketConnected = status;
        },
    },
    actions: {
        initializeSocket({ commit,dispatch }, authToken) {
            connectSocket(authToken);  // Connessione del socket

            onMessage((event) => {
                let message = JSON.parse(event.data);
                let messageType = message.messageType;

                let myUserId = sessionStorage.getItem('userId');
                let imPM = sessionStorage.getItem('isPM');
                let idTicketCategorie=JSON.parse(sessionStorage.getItem('ticketCategorie'));
                // Logica di gestione dei messaggi
                if (messageType === 'taskCreated') {
                    let messageContent = JSON.parse(message.messageContent);
                    if ((myUserId == message.userId || imPM == 'true') && idTicketCategorie.findIndex(tc=>tc===messageContent.idTicketCategoria)!=-1) {
                        setTimeout(() => {
                            commit("tasksCreatedFromWs", messageContent);
                        }, 1000);
                    }
                }
                if (messageType === 'taskDeleted') {
                    let messageContent = message.messageContent;
                    commit("taskDeletedFromWs", messageContent);
                }
                if (messageType === 'taskUpdated') {
                    let messageContent = JSON.parse(message.messageContent);
                    setTimeout(() => {

                        commit("taskUpdatedFromWs", messageContent);
                    }, 1000);
                }
                if (messageType === 'taskUpdatedParent') {
                    let messageContent = JSON.parse(message.messageContent);
                    setTimeout(() => {
                        commit("taskUpdatedFromWs", messageContent);
                    }, 1000);
                }
                if (messageType === 'taskUpdatedStatus') {
                    let messageContent = JSON.parse(message.messageContent);
                    if (imPM == 'true' || messageContent.tag !== 'PROGRAMMATO') {
                        commit("taskUpdatedStatusFromWs", messageContent);
                    }
                }
                if (messageType === 'notificaCreated') {
                    let messageContent = JSON.parse(message.messageContent);
                    if (myUserId == message.userId) {
                        commit("notificaCreatedFromWs", messageContent);
                    }
                }
                if (messageType === 'notificaGestita') {
                    let messageContent = JSON.parse(message.messageContent);
                    commit("taskGestitoWs", messageContent);
                }
                if (messageType === 'notificaRemoved') {
                    let messageContent = message.messageContent;
                    commit("notificaRemovedWs", messageContent);
                }
                if (messageType === 'taskUpdatedOwner') {
                    let messageContent = JSON.parse(message.messageContent);
                    setTimeout(()=>{
                        commit("taskUpdatedOwnerWs", {
                            idOwner: message.userId,
                            oldIdOwner: message.oldUserId,
                            messageContent: messageContent
                        });
                    },500)
                }

                if(messageType === 'taskPMUpdated'){
                    let messageContent = JSON.parse(message.messageContent);
                    commit("taskPMUpdatedWs", {
                        messageContent: messageContent
                    });
                }

                if(messageType==='tsAggiornati'){
                    let messageContent = JSON.parse(message.messageContent);
                    commit("tsAggiornatiWs", {
                        messageContent: messageContent
                    });
                }

                if(messageType==='managerNotificheCambiato'){
                    let messageContent = JSON.parse(message.messageContent);
                    commit("managerNotificheCambiato", {
                        idTaskSprint:messageContent.id,
                        idPmForzato:messageContent.idPmForzato,
                    });
                    dispatch("loadNotifiche");
                }

                if(messageType!=='pong' && messageType!=='ping')
                    commit("ADD_MESSAGE", event.data);
            });

            // Imposta lo stato della connessione
            commit("SET_SOCKET_CONNECTED", true);
        },
        sendSocketMessage({ commit }, message) {
            sendMessage(message);
        },
        closeSocketConnection({ commit }) {
            closeSocket(); // Chiudi il socket
            commit("SET_SOCKET_CONNECTED", false);
        },
    },
};

export { SocketStore };
